<template>
  <div>
    <tabs-container v-model="group_tabs" v-if="group_tabs.length > 0" />
    <div
      class="overflow-x-auto"
      v-for="quality_template_group in quality_template?.quality_template_groups"
      v-show="quality_template_group.quality_group == current_group"
      :key="quality_template_group.id"
    >
      <template v-if="sampling_values">
        <table class="table">
          <thead class="table-header">
            <tr>
              <th scope="col" class="table-header-cell px-2 text-center">
                <template v-if="Number(samplings) > 1"> # </template>
              </th>
              <th
                scope="col"
                class="table-header-cell px-0 text-center"
                v-for="quality_attribute in qualityAttributes(
                  quality_template_group
                )"
                :key="quality_attribute.id"
              >
                <div class="tooltip">
                  <p>
                    {{
                      quality_attribute?.abbreviation ??
                      quality_attribute?.crop_attribute?.name
                    }}
                  </p>
                  <span
                    v-if="quality_attribute.abbreviation"
                    class="tooltip-text"
                  >
                    {{ quality_attribute?.crop_attribute?.name }}
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr
              class="table-row"
              v-for="sampling in Number(samplings)"
              :key="sampling"
            >
              <td class="table-cell-pos px-2 text-center">
                <template v-if="Number(samplings) > 1">
                  {{ sampling }}
                </template>
              </td>
              <td
                v-for="quality_attribute in qualityAttributes(
                  quality_template_group
                )"
                class="table-cell px-0 text-center"
                :key="quality_attribute"
              >
                <sampling-value-input
                  v-if="
                    sampling_values[sampling] &&
                    sampling_values[sampling][
                      quality_template_group.quality_group.id
                    ]
                  "
                  :quality_attribute="quality_attribute"
                  :quality_group="quality_template_group.quality_group"
                  :sampling_values="sampling_values[sampling]"
                  v-model="
                    sampling_values[sampling][
                      quality_template_group.quality_group.id
                    ][quality_attribute.id]
                  "
                ></sampling-value-input>
              </td>
            </tr>
            <tr v-if="render_total">
              <td class="table-cell-pos px-2 text-center">Total</td>
              <td
                v-for="quality_attribute in qualityAttributes(
                  quality_template_group
                )"
                class="table-cell px-0 text-center"
                :key="quality_attribute"
              >
                <div
                  v-if="
                    quality_attribute.show_total &&
                    quality_attribute.calculate_general
                  "
                >
                  <p v-if="Number(samplings) > 1">
                    {{
                      numberWithPrecision(
                        getGeneralValueBySamplings(
                          quality_template_group.quality_group,
                          quality_attribute
                        )
                      )
                    }}
                  </p>
                  <p
                    v-if="
                      quality_template_group?.quality_group
                        ?.calculate_percentages
                    "
                  >
                    {{
                      getPercentageGeneralValueBySampling(
                        quality_template_group.quality_group,
                        quality_attribute
                      )
                    }}%
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
/* Usa la libreria ::Quality::Api::V1::FormLayoutJson de Rails para contruir el layout
 *
 */
import SamplingValueInput from "@/components/views/layout/quality_control/input/SamplingValueInput.vue";
import QualitySamplingMixin from "@/components/views/layout/quality_control/mixins/quality_sampling.js";
import QualityAttributeMixin from "@/components/views/mixins/models/quality_attribute.js";

export default {
  components: {
    SamplingValueInput,
  },
  mixins: [QualitySamplingMixin, QualityAttributeMixin],
  props: {
    quality_template: { required: true },
    samplings: { required: false, default: 0 },
    modelValue: { required: true },
    default_quality_samplings: { required: false, type: Array },
  },
  data() {
    return {
      sampling_values: null,
      group_tabs: [],
    };
  },
  computed: {
    all_attributes: function () {
      if (this.quality_template)
        return this.quality_groups
          .map((group) => group.quality_attributes)
          .flat();
      return [];
    },
    groups: function () {
      let groups = [];
      if (this.template)
        groups = this.template.quality_template_groups.map(
          (tp) => tp.quality_group
        );
      return groups;
    },
    parsed_samplings: function () {
      return this.parseSamplingValues();
    },
    current_group: function () {
      const current_tab = this.group_tabs.find((opt) => opt.current);
      return this.quality_groups.find((group) => group?.id == current_tab?.id);
    },
    render_total: function () {
      if (!this.current_group) return false;
      return (
        this.current_group.quality_attributes.filter(
          (attr) => attr.calculate_general && attr.show_total
        ).length > 0
      );
    },
    quality_groups: function () {
      let quality_groups = [];
      if (
        this.quality_template &&
        this.quality_template.quality_template_groups
      )
        quality_groups = this.quality_template.quality_template_groups.map(
          (tp) => tp.quality_group
        );
      return quality_groups;
    },
  },
  created() {
    this.fillSamplingValues();
  },
  methods: {
    getGeneralValueBySamplings: function (group, attribute) {
      if (!this.quality_template) return 0;
      let total = 0;
      for (let sampling = 1; sampling <= this.samplings; sampling++) {
        let value = 0;
        if (
          group.use_operation &&
          group.quality_attribute_id &&
          group.quality_attribute_id == attribute.id
        ) {
          value = this.calculateSamplingOperationByGroup(
            group,
            this.sampling_values[sampling]
          );
        } else {
          value = this.sampling_values[sampling][group.id][attribute.id];
        }
        if (value) total += value;
      }
      return total;
    },
    getPercentageGeneralValueBySampling: function (group, attribute) {
      let attribute_general = this.getGeneralValueBySamplings(group, attribute);
      if (!attribute_general) return 0;

      let total = 0;
      if (group?.use_operation) {
        const operation_attribute = this.all_attributes.find(
          (attr) => attr.id == group?.quality_attribute_id
        );
        if (!operation_attribute) return 0;

        total = this.getGeneralValueBySamplings(group, operation_attribute);
      } else {
        total = this.harvested_batch?.number_harvested_packages;
      }
      if (!Number(total)) return 0;

      return Number(this.getFormatNumber(100 * (attribute_general / total), 2));
    },
    getSamplingID: function (sampling) {
      if (!this.default_quality_samplings) return;

      sampling = this.default_quality_samplings?.find(
        (s) => s.sampling == sampling
      );
      if (sampling) return sampling.id;
      return null;
    },
    getSamplingGroupID: function (sampling_id, group) {
      if (!sampling_id) return;

      let sampling = this.default_quality_samplings.find(
        (s) => s.id == sampling_id
      );
      const sampling_group = sampling.quality_sampling_groups.find(
        (g) => g.quality_group_id == group.id
      );
      if (sampling_group) return sampling_group.id;
      return null;
    },
    getSamplingDetailID: function (sampling_group_id, attribute) {
      if (!sampling_group_id) return;

      let sampling_group = this.default_quality_samplings
        .map((s) => s.quality_sampling_groups)
        .flat()
        .find((sg) => sg.id == sampling_group_id);
      if (sampling_group) {
        const sampling_detail = sampling_group.quality_sampling_details.find(
          (d) => d.quality_attribute_id == attribute.id
        );
        if (sampling_detail) return sampling_detail.id;
      }
      return null;
    },
    qualityAttributes: function (quality_template_group) {
      return quality_template_group.quality_group.quality_attributes;
    },
    parseSamplingValues: function () {
      let quality_samplings = [];
      for (let sampling = 1; sampling <= Number(this.samplings); sampling++) {
        const id = this.getSamplingID(sampling);
        const quality_sampling_groups = this.qualitySamplingGroups(
          sampling,
          id
        );
        let quality_sampling = {
          id: id,
          sampling: sampling,
          accepted: true,
          quality_sampling_groups: quality_sampling_groups,
          _destroy:
            Boolean(id) &&
            !(quality_sampling_groups.filter((g) => !g._destroy).length > 0),
        };
        quality_samplings.push(quality_sampling);
      }
      const filtered_quality_samplings = quality_samplings.filter(
        (quality_sampling) =>
          quality_sampling.quality_sampling_groups.length > 0
      );
      return filtered_quality_samplings;
    },
    qualitySamplingGroups: function (sampling, sampling_id = null) {
      let groups = [];
      for (let i = 0; i < this.quality_groups.length; i++) {
        const group = this.quality_groups[i];
        const id = sampling_id
          ? this.getSamplingGroupID(sampling_id, group)
          : null;
        const quality_sampling_details = this.qualitySamplingDetails(
          sampling,
          group,
          id
        );
        let quality_sampling_group = {
          id: id,
          quality_group_id: group.id,
          quality_sampling_details: quality_sampling_details,
          _destroy:
            Boolean(id) &&
            !(quality_sampling_details.filter((d) => !d._destroy).length > 0),
        };
        groups.push(quality_sampling_group);
      }
      const filtered_groups = groups.filter((group) => {
        return group.quality_sampling_details.length > 0 || group._destroy;
      });
      return filtered_groups;
    },
    qualitySamplingDetails: function (
      sampling,
      group,
      sampling_group_id = null
    ) {
      let details = [];
      const attrs = group.quality_attributes;
      for (let i = 0; i < attrs.length; i++) {
        const attr = attrs[i];
        let detail = this.qualitySamplingDetail(
          sampling,
          group,
          attr,
          sampling_group_id
        );
        details.push(detail);
      }
      const filtered_details = details.filter(
        (detail) => !this.destroyableDetailValue(detail) || detail._destroy
      );
      return filtered_details;
    },
    qualitySamplingDetail: function (
      sampling,
      group,
      attribute,
      sampling_group_id = null
    ) {
      let value;
      let value_float;
      let value_bool;
      const id = this.getSamplingDetailID(sampling_group_id, attribute);
      if (group.use_operation && attribute.id == group.quality_attribute_id) {
        value = this.calculateSamplingOperationByGroup(
          group,
          this.sampling_values[sampling]
        );
      } else {
        value = this.sampling_values[sampling][group.id][attribute.id] ?? "";
      }
      if (value && this.qualityAttributeHasFloatValue(attribute))
        value_float = Number(value) ?? 0;
      if (this.qualityAttributeIsBoolean(attribute))
        value_bool = Boolean(value);
      let quality_sampling_detail = {
        id: id,
        quality_attribute_id: attribute.id,
        value: value ?? "",
        value_float: value_float ?? null,
        value_bool: value_bool ?? null,
        _destroy: null,
      };
      quality_sampling_detail._destroy =
        Boolean(quality_sampling_detail.id) &&
        this.destroyableDetailValue(quality_sampling_detail, attribute);
      return quality_sampling_detail;
    },
    /**
     * el valor del quality_sampling_detail que se usara para las operaciones
     * depende de su crop_attribute_type_id
     **/
    computedDetailValue: function (quality_sampling_detail, quality_attribute) {
      if (this.qualityAttributeIsBoolean(quality_attribute)) {
        return quality_sampling_detail.value_bool;
      } else if (this.qualityAttributeIsContinous(quality_attribute)) {
        return quality_sampling_detail.value_float;
      } else {
        return quality_sampling_detail.value;
      }
    },
    /**
     * identifica si el valor debe guardarse en la bd o no
     **/
    destroyableDetailValue: function (
      quality_sampling_detail,
      quality_attribute = null
    ) {
      if (!quality_attribute)
        quality_attribute = this.all_attributes.find(
          (attribute) =>
            attribute.id == quality_sampling_detail.quality_attribute_id
        );

      const value = this.computedDetailValue(
        quality_sampling_detail,
        quality_attribute
      );
      return !value;
    },
    fillTabs: function () {
      this.group_tabs = [];
      for (let i = 0; i < this.quality_groups.length; i++) {
        const group = this.quality_groups[i];
        this.group_tabs.push({
          id: group.id,
          name: group.name,
          current: i === 0,
        });
      }
    },
    fillSamplingValues: async function () {
      const old_sampling_values = this.sampling_values ?? {};
      let sampling_values = {};
      const groups = this.quality_groups ?? [];
      for (let sampling = 1; sampling <= Number(this.samplings); sampling++) {
        let old_sampling_value = old_sampling_values[sampling] ?? null;
        sampling_values[sampling] = old_sampling_value ?? {};
        if (old_sampling_value) continue;

        for (let g = 0; g < groups.length; g++) {
          let group = groups[g];
          sampling_values[sampling][group.id] = {};
        }
      }
      this.sampling_values = sampling_values;
      if (this.default_quality_samplings) this.setDefaultSamplingValues();
    },
    setDefaultSamplingValues: function () {
      for (let sampling = 1; sampling <= this.samplings; sampling++) {
        for (let group_i = 0; group_i < this.quality_groups.length; group_i++) {
          const group = this.quality_groups[group_i];
          for (
            let attr_i = 0;
            attr_i < group.quality_attributes.length;
            attr_i++
          ) {
            const attr = group.quality_attributes[attr_i];
            const value = this.getDefaultValue(sampling, group, attr);
            if (value)
              this.sampling_values[sampling][group.id][attr.id] = value;
          }
        }
      }
    },
    getDefaultQualitySampling: function (sampling) {
      return (
        this.default_quality_samplings.find(
          (quality_sampling) => quality_sampling.sampling == sampling
        ) ?? null
      );
    },
    getDefaultQualitySamplingGroup: function (quality_sampling, quality_group) {
      return (
        quality_sampling?.quality_sampling_groups.find(
          (quality_sampling_group) =>
            quality_sampling_group.quality_group_id == quality_group?.id
        ) ?? null
      );
    },
    getDefaultQualitySamplingDetail: function (
      quality_sampling_group,
      quality_attribute
    ) {
      return (
        quality_sampling_group?.quality_sampling_details.find(
          (quality_sampling_detail) =>
            quality_sampling_detail.quality_attribute_id ==
            quality_attribute?.id
        ) ?? null
      );
    },
    getDefaultValue: function (sampling, quality_group, quality_attribute) {
      const quality_sampling = this.getDefaultQualitySampling(sampling);
      const quality_sampling_group = this.getDefaultQualitySamplingGroup(
        quality_sampling,
        quality_group
      );
      const quality_sampling_detail = this.getDefaultQualitySamplingDetail(
        quality_sampling_group,
        quality_attribute
      );
      if (!quality_sampling_detail) return;

      return this.computedDetailValue(
        quality_sampling_detail,
        quality_attribute
      );
    },
  },
  watch: {
    quality_groups: {
      handler: function () {
        this.fillTabs();
      },
      deep: true,
      immediate: true,
    },
    samplings: {
      handler: function () {
        this.fillSamplingValues();
      },
      deep: true,
      immediate: true,
    },
    sampling_values: {
      handler: function () {
        let quality_samplings = this.parseSamplingValues();
        if (quality_samplings)
          this.$emit("update:modelValue", quality_samplings);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>